import React from "react";
import "../styles/Info.css";
import "../styles/LanguageSelector.css";
import { Language, eventInfoTranslations } from "../translations";
import { Gallery } from "../types";

interface EventInfoProps {
  language?: Language;
  onLanguageChange?: (language: Language) => void;
  showLanguageSelector?: boolean;
  gallery: Gallery;
}

const EventInfo: React.FC<EventInfoProps> = ({
  language = "en",
  onLanguageChange,
  showLanguageSelector = true,
  gallery,
}) => {
  console.log("", gallery, (gallery.date ?? "") >= "2026-02-07");
  const translations = eventInfoTranslations[language];

  const handleLanguageChange = (newLanguage: Language) => {
    if (onLanguageChange) {
      onLanguageChange(newLanguage);
    }
  };
  if (gallery.id === "8bc1a8d2-0576-4b1f-ad5a-894ca0a70932") {
    // Zawody Obedience Team Burki 20.09.2025
    return (
      <>
        <div className="info-container">
          <header>
            <h1>{gallery.i18n[language]?.title}</h1>
          </header>

          <hr />

          <section className="order-info">
            <h2>
              <span className="emojis">✉️</span> {translations.howToOrderTitle}
            </h2>
            <p>{translations.howToOrderText}</p>
            <ul>
              <li>
                <strong>Facebook:</strong>{" "}
                <a
                  href="https://www.facebook.com/MartaWlazloPhotography"
                  target="_blank"
                >
                  {translations.facebookText}
                </a>
              </li>
              <li>
                <strong>Instagram:</strong>{" "}
                <a
                  href="https://www.instagram.com/marta.wlazlo.photography"
                  target="_blank"
                >
                  {translations.instagramText}
                </a>
              </li>
            </ul>
          </section>

          <hr />

          <section className="price-list">
            <h2>
              <span className="emojis">💲</span> {translations.priceListTitle}
            </h2>
            <ul>
              <li>
                <strong>{translations.priceListOption1}</strong> – 150 zł
                <br />
                <strong>{translations.priceListOption2}</strong> – 25 zł
              </li>
              <li>
                <strong>{translations.priceListSingle}</strong> – 40 zł za każde
                zdjęcie
              </li>
            </ul>
            <div className="special-note">
              {translations.specialNoteEdited}
              <br />
              {translations.specialNoteAccess}
            </div>
          </section>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="info-container">
        <header>
          <h1>{gallery.i18n[language]?.title}</h1>
          {showLanguageSelector && (
            <div className="language-selector">
              <button
                className={language === "pl" ? "active" : ""}
                onClick={() => handleLanguageChange("pl")}
              >
                PL
              </button>
              <button
                className={language === "en" ? "active" : ""}
                onClick={() => handleLanguageChange("en")}
              >
                EN
              </button>
            </div>
          )}
        </header>

        <hr />

        <section className="order-info">
          <h2>
            <span className="emojis">✉️</span> {translations.howToOrderTitle}
          </h2>
          <p>{translations.howToOrderText}</p>
          <ul>
            <li>
              <strong>Facebook:</strong>{" "}
              <a
                href="https://www.facebook.com/MartaWlazloPhotography"
                target="_blank"
              >
                {translations.facebookText}
              </a>
            </li>
            <li>
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/marta.wlazlo.photography"
                target="_blank"
              >
                {translations.instagramText}
              </a>
            </li>
          </ul>
        </section>

        <hr />

        {(gallery.date ?? "") >= "2026-02-07" ? (
          <section className="price-list">
            <h2>
              <span className="emojis">💲</span> {translations.priceListTitle}
            </h2>
            <ul>
              <li>
                <strong>
                  {language === "pl"
                    ? "Pojedyncze zdjęcie"
                    : "Single photo"}
                </strong>{" "}
                – 40 zł / 10 €
              </li>
              <li>
                <strong>
                  {language === "pl"
                    ? "Przy zamówieniu 5 zdjęć — szóste gratis!"
                    : "Order 5 photos — get the 6th free!"}
                </strong>
              </li>
            </ul>
            <div className="special-note">
              {translations.specialNoteEdited}
              <br />
              {translations.specialNoteAccess}
            </div>
          </section>
        ) : gallery.photos[0]?.takenAt?.startsWith("2025-11-22") ? (
          <section className="price-list">
            <h2>
              <span className="emojis">💲</span> {translations.priceListTitle}
            </h2>
            <ul>
              <li>
                <strong>Pojedyncze zdjęcie (jeśli 4 lub mniej)</strong> – <s>40 zł</s> 30 zł (promocja)
              </li>
              <li>
                <strong>Każde dodatkowe zdjęcie (od piątego)</strong> – 25 zł
              </li>
            </ul>
            <div className="special-note">
              {translations.specialNoteEdited}
              <br />
              {translations.specialNoteAccess}
            </div>
          </section>
        ) : (
          <section className="price-list">
            <h2>
              <span className="emojis">💲</span> {translations.priceListTitle}
            </h2>
            <ul>
              <li>
                <strong>{translations.priceListOption1}</strong> –{" "}
                {translations.priceListAdditional}
                <br />
                <strong>{translations.priceListOption2}</strong> – 25 zł / 6 €
              </li>
              <li>
                <strong>{translations.priceListSingle}</strong> – 40 zł / 9 € per
                photo
              </li>
            </ul>
            <div className="special-note">
              {translations.specialNoteEdited}
              <br />
              {translations.specialNoteAccess}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default EventInfo;
